import { render, staticRenderFns } from "./DataRecording.vue?vue&type=template&id=473fc66c&scoped=true&"
import script from "./DataRecording.vue?vue&type=script&lang=js&"
export * from "./DataRecording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473fc66c",
  null
  
)

export default component.exports